import { stockMessage } from "../helpers/stockMessage/stockMessage";

/**
 * The lead time / stock message on a cart line, composed here rather than in
 * Liquid so it stays the same message the product form shows.
 *
 * The variant attributes are re-rendered by Liquid on every cart paint and the
 * element is rebuilt with them (`data-force-update`), so a message naming a ship
 * date tracks the variant instead of freezing at the moment the line was added.
 * The monogram's lead time is the one part that can't change once the line is in
 * the cart, and arrives already composed from its line item property. The gift
 * box note arrives composed too, and is cart-only — the product form doesn't
 * show it.
 */
class StockMessage extends HTMLElement {
  connectedCallback() {
    const variant = {
      customColor: this.getAttribute("custom-color"),
      currentlyNotInStock:
        this.getAttribute("currently-not-in-stock") === "true",
      backInStockDate: this.getAttribute("back-in-stock-date"),
      leadTime: this.getAttribute("lead-time"),
    };

    this.textContent = [
      stockMessage(variant),
      this.getAttribute("monogram-lead-time"),
      this.getAttribute("gift-box-message"),
    ]
      .filter(Boolean)
      .join(" ");
  }
}

if (!customElements.get("stock-message")) {
  customElements.define("stock-message", StockMessage);
}
